import React from 'react';
import { useTranslation } from 'react-i18next';
import { VALUE_PROPS_SMB, VALUE_PROPS_VENDOR, VALUE_PROPS_GENERAL } from './linkedin-ads-data';

/* Props: { audience } */
const LinkedInAdsBenefits = ({ audience }) => {
  const { t } = useTranslation();

  const valueProps = audience === 'smb' ? VALUE_PROPS_SMB :
                     audience === 'vendor' ? VALUE_PROPS_VENDOR :
                     VALUE_PROPS_GENERAL;

  return (
    <>
      <section className="pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6">
            {valueProps.map(({ icon: Icon, key, translationKey }) => (
              <div
                key={key}
                className="bg-background border border-border rounded-lg p-6 hover:border-primary/30 transition-colors"
              >
                <Icon className="w-8 h-8 text-primary mb-4" />
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {t(`${translationKey}.title`)}
                </h3>
                <p className="text-muted-foreground">
                  {t(`${translationKey}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-secondary/30 border border-border rounded-xl p-8">
          <div className="text-center mb-6">
            <p className="text-sm font-medium text-primary mb-2">{t('linkedin.social.badge')}</p>
            <h2 className="text-2xl font-bold text-foreground">
              {t('linkedin.social.title')}
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div>
              <p className="text-3xl font-bold text-primary mb-1">
                {t('linkedin.social.stat1Number')}
              </p>
              <p className="text-sm text-muted-foreground">
                {t('linkedin.social.stat1Label')}
              </p>
            </div>
            <div>
              <p className="text-3xl font-bold text-primary mb-1">
                {t('linkedin.social.stat2Number')}
              </p>
              <p className="text-sm text-muted-foreground">
                {t('linkedin.social.stat2Label')}
              </p>
            </div>
            <div>
              <p className="text-3xl font-bold text-primary mb-1">
                {t('linkedin.social.stat3Number')}
              </p>
              <p className="text-sm text-muted-foreground">
                {t('linkedin.social.stat3Label')}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LinkedInAdsBenefits;
